import { useQuery } from '@apollo/client';

import { EnterpriseLoyaltySettingsDocument } from 'src/gql/graphql';
import type { EnterpriseLoyaltySettingsQuery } from 'src/gql/graphql';
import '../queries/enterprise-loyalty-settings.gql';

type UseSearchEnterpriseParams = {
  enterpriseId?: string;
};

type UseSearchEnterpriseReturn = {
  enterprise: EnterpriseLoyaltySettingsQuery['enterpriseLoyaltySettings'];
  loading: boolean;
  error: any;
};

export function useSearchEnterprise({ enterpriseId }: UseSearchEnterpriseParams): UseSearchEnterpriseReturn {
  const skip = !enterpriseId;

  const { data, loading, error } = useQuery(EnterpriseLoyaltySettingsDocument, {
    variables: { enterpriseId: enterpriseId ?? '' },
    skip,
  });

  return {
    enterprise: data?.enterpriseLoyaltySettings ?? null,
    loading,
    error,
  };
}
